<div class="edit-day-schedule-container">
  <mwo-edit-day-schedule-item (onDelete)="handleDelete(i)" (onEdit)="handleEdit(i)" class="schedule-items"
                              *ngFor="let item of list; let i = index" [activeEdit]="i == currentEditIndex"
                              [disableDelete]="currentEditIndex != -1"
                              [timeSlot]="item"></mwo-edit-day-schedule-item>
</div>
